export const selectStyle = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "#F8F6FE",
    border: "1px solid #f0eefa",
    color: "#47495c",
  }),
  menu: (styles) => ({
    ...styles,
    zIndex: 100,
  }),
  option: (styles) => ({
    ...styles,
    color: "#47495c",
  }),
};
